import FloorFilter from "../data/floor-filter";
import React, { useCallback } from "react";
import * as styles from "./floor-filter-button.module.scss";
import IconFloors from "../dynamicicons/icon-floors";
import IconFloorCurrent from "../dynamicicons/icon-floor-current";
import { mapFloorNumber } from "../helper/language-helper";

export interface FloorFilterButtonProps {
	selection?: number;
	onChange: (filter: FloorFilter) => void;
}

export default function FloorFilterButton(props: FloorFilterButtonProps) {
	const selection = props.selection;
	const onChange = props.onChange;

	const toggle = useCallback(() => {
		if (selection === undefined) {
			onChange(FloorFilter.Current);
		} else {
			onChange(FloorFilter.All);
		}
	}, [selection, onChange]);

	return (
		<div className={styles.floorButtonWrapper}>
			<button className={styles.floorButton} onClick={toggle}>
				{props.selection === undefined ? (
					<>
						<IconFloors color="#5F718C" />
						<span>All</span>
					</>
				) : (
					<>
						<IconFloorCurrent color="#5F718C" />
						<span>{mapFloorNumber(props.selection)}</span>
					</>
				)}
			</button>
		</div>
	);
}
